import {
  transformBonusLabelToDisplay,
  transformStateBonus,
  transformBonusManagementLabelToDisplay,
} from "@/utils/dataHandlers/Transformers";
import { getUrl } from "@/utils/commonUtils";
import {
  RECARGA_CONTRA_TARJETA_IFRAME_MP,
  RECARGA_CONTRA_TARJETA_IFRAME_MP_OK_KO,
  RECARGA_CONTRA_TARJETA_IFRAME_MPWB,
  RECARGA_CONTRA_TARJETA_IFRAME_MPWB_OK_KO,
  RECARGA_CONTRA_TARJETA_IFRAME_MOV_OK_KO,
  RECARGA_CONTRA_TARJETA_IFRAME_MOV,
  RECARGA_CONTRA_TARJETA_IFRAME_MOVWB_OK_KO,
  RECARGA_CONTRA_TARJETA_IFRAME_MOVWB,
  MOBILE_PREPAID,
  BONO_EXTRA_200MB,
  BONO_INTERNACIONAL_100MB,
  BONO_HABLA_MAS,
  BONO_NAVEGA_MAS,
  BONO_HABLA_LATINO,
  BONO_HABLA_MUNDO,
  BONO_EXTRA_200MB_C2C,
  BONO_INTERNACIONAL_100_C2C,
  BONO_HABLA_MAS_C2C,
  BONO_NAVEGA_MAS_C2C,
  BONO_HABLA_LATINO_C2C,
  BONO_HABLA_MUNDO_C2C,
  URL_C2C,
  BONOS_PREPAGO_ID,
} from "@/constants/constants";

export const getColorPriceMovement = (price, extraUsage) => {
  let color = "";
  // const newPrice = parseInt(price, 10);
  const newPrice = parseFloat(price);
  if (newPrice > 0) {
    color = extraUsage ? "textRed" : "text";
  } else if (newPrice < 0) {
    color = extraUsage ? "textRed" : "text";
  }
  return color;
};
export const getAllContractedBonusFromMyAccumulatedUsageProduct = (
  myAccumulatedUsageProduct
) => {
  const { data, voice } = myAccumulatedUsageProduct;
  const bonus = [];
  data.bonus.forEach((bonu) => {
    bonus.push(bonu);
  });
  voice.bonus.forEach((bonu) => {
    bonus.push(bonu);
  });
  return [...new Set([].concat(...bonus))];
};
export const bonusToShowInMain = (idBono) => {
  switch (idBono) {
    case BONOS_PREPAGO_ID.remanentes.datos:
    case BONOS_PREPAGO_ID.remanentes.voz:
    case BONOS_PREPAGO_ID.franquicia.prepago5.voz:
    case BONOS_PREPAGO_ID.franquicia.prepago5.datos:
    case BONOS_PREPAGO_ID.franquicia.prepago7.voz:
    case BONOS_PREPAGO_ID.franquicia.prepago7.datos:
    case BONOS_PREPAGO_ID.franquicia.prepago15.voz:
    case BONOS_PREPAGO_ID.franquicia.prepago15.datos:
    case BONOS_PREPAGO_ID.voz.internacional:
      return false;
    default:
      return true;
  }
};
export const getAllContractedBonusToShow = (bonus) => {
  let moreThanOnePromox2 = false;
  const bonusToShow = [];
  bonus.forEach((bonu) => {
    if (
      bonu.id === BONOS_PREPAGO_ID.datos.duplicacionGB.prepago5 ||
      bonu.id === BONOS_PREPAGO_ID.datos.duplicacionGB.prepago7 ||
      bonu.id === BONOS_PREPAGO_ID.datos.duplicacionGB.prepago15
    ) {
      if (!moreThanOnePromox2) {
        moreThanOnePromox2 = true;
        bonusToShow.push(bonu);
      }
    } else if (bonusToShowInMain(bonu.id)) {
      bonusToShow.push(bonu);
    }
  });
  return [...new Set([].concat(...bonusToShow))];
};
export const getBonusLabel = (bonu) => {
  const label = transformBonusLabelToDisplay(bonu);
  return label;
};

export const getUrlIframe = (origin, paramURL) => {
  let iFrameURL = "";
  switch (origin) {
    case "misProductos":
      iFrameURL =
        paramURL && paramURL === "?vm=1"
          ? RECARGA_CONTRA_TARJETA_IFRAME_MP_OK_KO
          : RECARGA_CONTRA_TARJETA_IFRAME_MP;
      /* if (paramURL === '?recargafavorita=true') {
        iFrameURL = RECARGA_FAVORITA;
      } else if (paramURL === '?recargafavorita=true&vm=1' || paramURL === '?recargafavorita=true&vm=0') {
        iFrameURL = RECARGA_FAVORITA_OK_KO;
      } */
      break;
    case "misProductosWB":
      iFrameURL =
        paramURL && paramURL === "?vm=1"
          ? RECARGA_CONTRA_TARJETA_IFRAME_MPWB_OK_KO
          : RECARGA_CONTRA_TARJETA_IFRAME_MPWB;
      break;
    case "movimientos":
      iFrameURL =
        paramURL && paramURL === "?vm=1"
          ? RECARGA_CONTRA_TARJETA_IFRAME_MOV_OK_KO
          : RECARGA_CONTRA_TARJETA_IFRAME_MOV;
      break;
    case "movimientosWB":
      iFrameURL =
        paramURL && paramURL === "?vm=1"
          ? RECARGA_CONTRA_TARJETA_IFRAME_MOVWB_OK_KO
          : RECARGA_CONTRA_TARJETA_IFRAME_MOVWB;
      break;
    default:
      break;
  }
  return iFrameURL;
};

export const getBalancePrepaidByProductId = (balancesPrepaid, productId) => {
  let balancePrepaidFound = {};
  if (balancesPrepaid) {
    balancePrepaidFound = balancesPrepaid.find(
      (balancePrepaidObj) => balancePrepaidObj.productId === productId
    );
  }
  return balancePrepaidFound;
};
export const getLinesMobileNonPrepaidFromHiredProducts = (hiredProducts) => {
  const linesMobilesFiltered = hiredProducts.map((element) => {
    if (
      element.mobile &&
      element.mobile.linesMobile &&
      element.productType !== MOBILE_PREPAID
    ) {
      return element.mobile.linesMobile;
    }
    return null;
  });
  return [...new Set(...linesMobilesFiltered)];
};

export const getUrlBonusById = (idBonu) => {
  let urlCTC = null;
  switch (idBonu) {
    case BONOS_PREPAGO_ID.datos.extra200mb:
      urlCTC = BONO_EXTRA_200MB;
      break;
    case BONOS_PREPAGO_ID.voz.internacional100:
      urlCTC = BONO_INTERNACIONAL_100MB;
      break;
    case BONOS_PREPAGO_ID.voz.hablaMas:
      urlCTC = BONO_HABLA_MAS;
      break;
    case BONOS_PREPAGO_ID.datos.navegaMas:
      urlCTC = BONO_NAVEGA_MAS;
      break;
    case BONOS_PREPAGO_ID.voz.hablaLatino:
      urlCTC = BONO_HABLA_LATINO;
      break;
    case BONOS_PREPAGO_ID.voz.hablaMundo:
      urlCTC = BONO_HABLA_MUNDO;
      break;
    default:
  }
  return urlCTC;
};
export const getBonusManagementLabel = (contractedBond) => {
  const label = transformBonusManagementLabelToDisplay(contractedBond);
  return label;
};
export const getRadioButtonSettingPrepaid = (
  bonus,
  productId,
  novum,
  urlLibrary
) => {
  const link2use = novum
    ? getUrl("bonusProductSheetPrepaidNovum", urlLibrary)
    : getUrl("bonusProductSheetPrepaid", urlLibrary);
  const bonusSetting = [];
  bonus.forEach((bonu) => {
    const bonuSetting = {
      label: bonu.label,
      labelPrice: bonu.unit,
      value: bonu.id,
      infoLabel: "Más información",
      endDate: bonu.contractedBond ? bonu.contractedBond.endDate : "",
      description: bonu.contractedBond ? bonu.contractedBond.description : "",
      numberTimesContracted: bonu.contractedBond
        ? bonu.contractedBond.numberTimesContracted
        : "",
      state: bonu.contractedBond
        ? transformStateBonus(bonu.contractedBond.state)
        : "",
      bonusLabel: bonu.contractedBond
        ? getBonusManagementLabel(bonu.contractedBond)
        : "",
      infoUrl: `${link2use}/${productId}/${bonu.id}`,
    };
    bonusSetting.push(bonuSetting);
  });

  return bonusSetting;
};
export const getUrlCTChireBonusById = (idBonu) => {
  let urlCTC = null;
  switch (idBonu) {
    case BONOS_PREPAGO_ID.datos.extra200mb:
      urlCTC = BONO_EXTRA_200MB_C2C;
      break;
    case BONOS_PREPAGO_ID.voz.internacional100:
      urlCTC = BONO_INTERNACIONAL_100_C2C;
      break;
    case BONOS_PREPAGO_ID.voz.hablaMas:
      urlCTC = BONO_HABLA_MAS_C2C;
      break;
    case BONOS_PREPAGO_ID.datos.navegaMas:
      urlCTC = BONO_NAVEGA_MAS_C2C;
      break;
    case BONOS_PREPAGO_ID.voz.hablaLatino:
      urlCTC = BONO_HABLA_LATINO_C2C;
      break;
    case BONOS_PREPAGO_ID.voz.hablaMundo:
      urlCTC = BONO_HABLA_MUNDO_C2C;
      break;
    default:
  }
  return urlCTC;
};

export const getUrlCTCListTariff = (serviceClickToCall) => {
  const urlCTCTariff = `${URL_C2C}${serviceClickToCall}`;

  return urlCTCTariff;
};

export const createCycleObject = (dateString, productId) => {
  // Helper function to format date objects as "dd-MM-yyyy"
  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // Helper function to calculate the difference in days between two dates
  function calculateDaysDifference(date1, date2) {
    const oneDay = 24 * 60 * 60 * 1000; // milliseconds in one day
    const diffInTime = date1.getTime() - date2.getTime();
    return Math.round(diffInTime / oneDay);
  }

  // Parse the input date string "18/08/2024 - 12:46"
  const [datePart, timePart] = dateString.split(" - ");
  const [day, month, year] = datePart.split("/").map(Number);
  const endDate = new Date(year, month - 1, day);

  // Calculate the start cycle date (end date minus 28 days)
  const startCycleDate = new Date(endDate);
  startCycleDate.setDate(startCycleDate.getDate() - 28);

  // Calculate the remaining days between endDate and startCycleDate
  const remainingDays = calculateDaysDifference(endDate, new Date());

  // Create the desired object
  const result = {
    endCycle: formatDate(endDate),
    productId: productId,
    remainingDays: remainingDays,
    startCycle: formatDate(startCycleDate),
  };

  return result;
};

export const check118Service = (movement) => {
  if (movement) {
    const { pricePrestador } = movement;
    if (pricePrestador) {
      return true;
    }
  }
  return false;
};

export const numberPrice2ClientStringPrice = (
  number,
  decimals = 2,
  decimalChar = ",",
  thousandChar = "."
) => {
  let res = number;
  res = parseFloat(res).toFixed(decimals);
  res = res.replace(".", decimalChar);
  const splitNum = res.split(decimalChar);
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandChar);
  res = splitNum.join(decimalChar);
  return res;
};

export const getPriceMovement = (movement, totalPrice) => {
  if (!movement) {
    return null;
  }
  let priceToPaint = null;
  const price = totalPrice ? movement.totalPrice : movement.price;
  if (price) {
    const firstChar = price.charAt(0);
    switch (firstChar) {
      case "+":
        priceToPaint = price.split(" ")[1];
        break;
      case "-":
        priceToPaint = price;
        break;
      default:
        priceToPaint = `-${price}`;
        break;
    }
  } else {
    priceToPaint = "0.00";
  }
  return priceToPaint;
};

export const getPricePrestadorMovement = (movement) => {
  if (!movement) {
    return null;
  }
  let priceToPaint = null;
  const { pricePrestador } = movement;
  const firstChar = pricePrestador.charAt(0);
  switch (firstChar) {
    case "+":
      priceToPaint = pricePrestador.split(" ")[1];
      break;
    case "-":
      priceToPaint = pricePrestador;
      break;
    default:
      priceToPaint = `-${pricePrestador}`;
      break;
  }
  return priceToPaint;
};
